<template>
  <section v-if="alerts.length" class="voucher-sequence-notice"
    aria-label="Aviso de reposición de comprobantes" aria-live="polite">
    <p class="voucher-sequence-notice-heading">Comprobantes por reponer · {{ alerts.length }}</p>
    <p class="voucher-sequence-notice-guidance">Solicita más números antes de agotarlos.</p>
    <div class="voucher-sequence-notice-list">
      <VoucherReplenishmentAlert v-for="alert in alerts" :key="alert.id"
        :alert="alert" :can-manage="canManage" compact @replenish="$emit('replenish', $event)" />
    </div>
  </section>
</template>

<script>
import VoucherReplenishmentAlert from "../PublicComponents/VoucherReplenishmentAlert.vue";

export default {
  name: "VoucherSequenceNotice",
  components: { VoucherReplenishmentAlert },
  props: {
    alerts: { type: Array, required: true },
    canManage: Boolean,
  },
  emits: ["replenish"],
};
</script>

<style scoped>
.voucher-sequence-notice {
  flex: 0 0 100%;
  min-width: 0;
  padding: 8px;
  border: 2px solid #dc2626;
  border-radius: 8px;
  background: #fef2f2;
  color: #991b1b;
}
.voucher-sequence-notice-heading { font-size: 13px; font-weight: 700; }
.voucher-sequence-notice-guidance { font-size: 12px; }
.voucher-sequence-notice-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 19rem), 1fr));
  gap: 6px;
  margin-top: 6px;
  max-height: min(180px, 24vh);
  overflow-y: auto;
  overscroll-behavior: contain;
}
</style>
